document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.submenu-toggle');
  if (!toggle) return;
  const li = toggle.closest('.menu-item');
  const link = li.querySelector('.nav-link');
  const open = li.classList.toggle('open');
  toggle.setAttribute('aria-expanded', open);
  if (link) link.setAttribute('aria-expanded', open);
});

document.addEventListener('click', (e) => {
  if (!e.target.closest('.menu')) {
    document.querySelectorAll('.menu-item.open').forEach(li => {
      li.classList.remove('open');
      li.querySelectorAll('[aria-expanded="true"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
    });
  }
});